import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ConfirmRequest,
  EmptySuccessfulResponse,
  PspOfferService,
  SectionResponse,
  PaginatedApiResponseWithFilters,
  OverlapFiltersResponse,
} from '../../../api';

@Injectable({ providedIn: 'root' })
export class BaseOffersAndBookingsService {
  constructor(private pspOfferService: PspOfferService) {}

  getPspOfferOverlapList(params: { psp: number; page?: any; size?: any; profiles?: any; customers?: any }): Observable<
    PaginatedApiResponseWithFilters & {
      data?: Array<SectionResponse>;
      filters?: OverlapFiltersResponse;
    }
  > {
    return this.pspOfferService.getPspOfferOverlapList({
      psp: params.psp,
      page: params.page,
      size: params.size,
      profile: params.profiles,
      customer: params.customers,
    });
  }

  confirmPspInquiryOffer(params: {
    psp: number;
    inquiry: number;
    offer: number;
    body: ConfirmRequest;
  }): Observable<EmptySuccessfulResponse> {
    return this.pspOfferService.postPspInquiryOfferConfirm(params);
  }

  withdrawPspInquiryOffer(params: {
    psp: number;
    inquiry: number;
    offer: number;
  }): Observable<EmptySuccessfulResponse> {
    return this.pspOfferService.deletePspInquiryOfferWithdraw(params);
  }
}
